import React from 'react'

const FourOFour = () => {
  return <h1 css={{ margin: `auto` }}>Page not found</h1>
}

export default FourOFour
